// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3hZYl","choiceBoxes":"toolbarselects_choiceBoxes__1-35X","simpleField":"toolbarselects_simpleField__2Ny2w"};